export const CREATE_BENEFICIARY = `
mutation CreateCustomerBeneficiary($beneficiaryType: String!, $firstName: String, $middleName: String, $lastName: String, $dateOfBirth: String, $customerRelationshipId: ID, $benefitsPercentage: Float!, $idTypeId: ID, $idNumber: String, $phoneNumber: String, $emailAddress: String, $customerSubscriptionId: ID!, $guardianName: String, $guardianAddress: String, $guardianPhoneNumber: String, $guardianEmail: String, $institutionName: String, $institutionAddress: String, $institutionPhoneNumber: String, $titleId: ID ) {
  createCustomerBeneficiary(beneficiaryType: $beneficiaryType, firstName: $firstName, middleName: $middleName, lastName: $lastName, dateOfBirth: $dateOfBirth, customerRelationshipId: $customerRelationshipId, benefitsPercentage: $benefitsPercentage, idTypeId: $idTypeId, idNumber: $idNumber, phoneNumber: $phoneNumber, emailAddress: $emailAddress, customerSubscriptionId: $customerSubscriptionId, guardianName: $guardianName, guardianAddress: $guardianAddress, guardianEmail: $guardianEmail, guardianPhoneNumber: $guardianPhoneNumber, institutionName: $institutionName, institutionPhoneNumber: $institutionPhoneNumber, institutionAddress: $institutionAddress, titleId: $titleId){
    beneficiaries {
      id
      beneficiaryType
      firstName
      middleName
      lastName
      dateOfBirth
      isActive
      benefitsPercentage
      fullname
      idType {
        id
        name
      }
      title {
        id
        name
      }
      idNumber
      phoneNumber
      emailAddress
      institutionName
      institutionAddress
      institutionPhoneNumber
      guardianName
      guardianPhoneNumber
      guardianAddress
      guardianEmail
      customerSubscription {
        id
      }
      customerRelationship {
        id
        name
      }
    }
    errors {
      property
      description
    }
  }
}
`

export const UPDATE_BENEFICIARY = `
mutation UpdateCustomerBeneficiary($beneficiaryType: String!, $id: ID!, $firstName: String, $middleName: String, $lastName: String, $dateOfBirth: String, $customerRelationshipId: ID, $benefitsPercentage: Float!, $idTypeId: ID, $idNumber: String, $phoneNumber: String, $emailAddress: String, $customerSubscriptionId: ID!, $guardianName: String, $guardianAddress: String, $guardianPhoneNumber: String, $institutionName: String, $institutionAddress: String, $institutionPhoneNumber: String, $titleId: ID ) {
  updateCustomerBeneficiary(beneficiaryType: $beneficiaryType, id: $id, firstName: $firstName, middleName: $middleName, lastName: $lastName, dateOfBirth: $dateOfBirth, customerRelationshipId: $customerRelationshipId, benefitsPercentage: $benefitsPercentage, idTypeId: $idTypeId, idNumber: $idNumber, phoneNumber: $phoneNumber, emailAddress: $emailAddress, customerSubscriptionId: $customerSubscriptionId, guardianName: $guardianName, guardianAddress: $guardianAddress, guardianPhoneNumber: $guardianPhoneNumber, institutionName: $institutionName, institutionPhoneNumber: $institutionPhoneNumber, institutionAddress: $institutionAddress, titleId: $titleId){
    beneficiaries {
      id
      beneficiaryType
      firstName
      middleName
      lastName
      dateOfBirth
      benefitsPercentage
      isActive
      fullname
      idType {
        id
        name
      }
      title {
        id
        name
      }
      idNumber
      phoneNumber
      emailAddress
      institutionName
      institutionAddress
      institutionPhoneNumber
      guardianName
      guardianPhoneNumber
      guardianAddress
      customerSubscription {
        id
      }
      customerRelationship {
        id
        name
      }
    }
    errors {
      property
      description
    }
  }
}
`

export const DELETE_BENEFICIARY = `
mutation DeleteBeneficiary($id: ID!) {
  deleteCustomerBeneficiary(id: $id){
    result
    beneficiaries {
      id
      beneficiaryType
      firstName
      middleName
      lastName
      isActive
      deletedAt
      customerSubscription{
        id
      }
      dateOfBirth
      benefitsPercentage
      fullname
      idType {
        id
        name
      }
      title {
        id
        name
      }
      idNumber
      phoneNumber
      emailAddress
      customerRelationship {
        id
        name
      }
    }
    errors {
      property
      description
    }
  }
}
`;
